export enum rotinas {
    PERFIL_DE_ACESSO = "PerfilAcesso",
    CLIENTE = "VWCliente",
    USUARIO = "VWUsuario",
    DEPARTAMENTO = "Departamento"
}